import { openUrlInNewWindow } from ':cloud/utils/openUrlInNewWindow';

export function onExternalLinkPress(url: string) {
  return () => openUrlInNewWindow(url);
}
